import script from "./PayoutHistoryList.vue?vue&type=script&lang=ts&setup=true"
export * from "./PayoutHistoryList.vue?vue&type=script&lang=ts&setup=true"

import "./PayoutHistoryList.vue?vue&type=style&index=0&id=3bf328a2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bf328a2"]])

export default __exports__